import { FC } from 'react'
import { Image } from '@/atoms/Image'
import { MomentTypes } from '@/types/codegen-federation'

type CollectibleType = MomentTypes

interface CollectibleLogoProps {
  collectibleType: CollectibleType
  height: number
  width: number
}

export const CollectibleLogo: FC<CollectibleLogoProps> = ({ collectibleType, width, height }) => {
  return collectibleType === 'GOLDEN' ? (
    <Image
      loading="eager"
      alt="golden collectible scene logo"
      src="/v1683817411/angel-studios/collectibles/golden-collectible-badge.png"
      width={width}
      height={height}
      style={{ maxWidth: '100%', height: 'auto' }}
    />
  ) : (
    <Image
      loading="eager"
      alt="collectible scene logo"
      src="/v1683817411/angel-studios/collectibles/collectible-badge.png"
      width={width}
      height={height}
    />
  )
}
